import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

import {} from '@angular/common/http';

// Validateur personnalisé pour vérifier que les deux mots de passe correspondent.
export function passwordMatcher(
  control: AbstractControl,
): ValidationErrors | null {
  const password = control.get('password')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;
  return password === confirmPassword ? null : { passwordsMismatch: true };
}

@Component({
  selector: 'app-register',
  imports: [ReactiveFormsModule, RouterModule],
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);

  registerForm: FormGroup;
  isLoading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  selectedPlan: string = 'free'; // Par défaut sur le plan gratuit

  constructor() {
    this.registerForm = this.fb.group(
      {
        email: ['', [Validators.required, Validators.email]],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            ),
          ],
        ],
        confirmPassword: ['', [Validators.required]],
        businessName: ['', [Validators.required]],
        acceptedCGU: [false, [Validators.requiredTrue]], // Doit être cochée
      },
      { validators: passwordMatcher },
    );
  }

  ngOnInit(): void {
    // Priorité 1: query param (?plan=starter depuis landing)
    const planFromUrl = this.route.snapshot.queryParamMap.get('plan');
    if (
      planFromUrl &&
      ['starter', 'pro', 'business'].includes(planFromUrl.toLowerCase())
    ) {
      this.selectedPlan = planFromUrl.toLowerCase();
      this.authService.setSelectedPlan(this.selectedPlan);
    } else {
      // Priorité 2: sessionStorage (sélection antérieure)
      const plan = this.authService.getSelectedPlan();
      this.selectedPlan = plan ?? 'free';
    }
  }

  onSubmit(): void {
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.errorMessage = null;
    this.successMessage = null;

    const { email, password, businessName } = this.registerForm.value;

    // Passe selectedPlan au backend pour persistance
    this.authService
      .register({
        email,
        password,
        businessName,
        acceptedCGU: this.registerForm.value.acceptedCGU,
        selectedPlan:
          this.selectedPlan !== 'free' ? this.selectedPlan : undefined,
      })
      .subscribe({
        next: () => {
          // Message de succès et redirection vers la page "Please verify"
          this.successMessage = `Email de confirmation envoyé à ${email}. Vérifie ta boîte mail.`;
          this.router.navigate(['/please-verify']);
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.errorMessage =
            err.error?.message ||
            "Une erreur est survenue lors de l'inscription.";
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        complete: () => {
          this.isLoading = false;
          this.cdr.markForCheck();
        },
      });
  }
}
